export const EAccrualEventType = {
  Accrual: "Accrual",
  Usage: "Usage",
  Reversal: "Reversal",
} as const;

export type TAccrualEventType =
  (typeof EAccrualEventType)[keyof typeof EAccrualEventType];
